<template>
  <div class="invoice">
    <h3>发票管理</h3>
    <div class="invoice-info-head">
      <span
        :class="currentIndex == index ?'active':''"
        @click="changeTabIndex(index)"
        v-for="(item,index) in tabhead"
        :key="index"
      >{{item}}</span>
    </div>
    <div class="main-box" v-if="this.currentIndex == 0">
      <invoiceinfo></invoiceinfo>
    </div>
    <div class="main-box" v-if="this.currentIndex == 1">
      <invoiceAddress></invoiceAddress>
    </div>
  </div>
</template>

<script>
import invoiceinfo from "./InvoiceControlRight/children/invoiceinfo";
import invoiceAddress from "./InvoiceControlRight/children/invoiceAddress";
export default {
  components: {
    invoiceinfo,
    invoiceAddress
  },
  data() {
    return {
      tabhead: ["发票信息管理", "发票地址管理"],
      currentIndex: 0
    };
  },
  methods: {
    changeTabIndex(index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style lang="less" scoped>
h3 {
  font-size: 24px;
  color: #333333;
}
.invoice-info-head {
  width: 876px;
  height: 58px;
  background: #f5f5f5;
  border: 1px solid #dddddd;
  font-size: 18px;
  line-height: 58px;
  color: #333333;
  margin: 10px 0px;
  span {
    margin-left: 21px;
    line-height: 36px;
    padding: 10px;
    margin-right: 25px;
    cursor: pointer;
    color: #999;
    &.active {
      color: #000;
    }
  }
}
</style>